import { createAsyncThunk } from '@reduxjs/toolkit';

import { VendorsResponseSchema } from '../types/VendorsSchema';

import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export const fetchPropertyVendorsList = createAsyncThunk<
    VendorsResponseSchema,
    string,
    ThunkConfig<string>
>('vendors/listVendors', async (propertyId, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;

    try {
        const response = await extra.api.get<VendorsResponseSchema>(
            `/v1/properties/${propertyId}/vendors`,
        );

        return response.data;
    } catch (e) {
        return rejectWithValue('error');
    }
});
